var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	"2228aea9386c33236da4": () => (loadStrictVersionCheckFallback("default", "@wolffun/env-var", [0], () => (Promise.all([__webpack_require__.e(1858), __webpack_require__.e(6195)]).then(() => (() => (__webpack_require__("b121b2c4010b7dd13002"))))))),
	"4914e017dcea24a7ed64": () => (loadStrictVersionCheckFallback("default", "react", [1,17,0,2], () => (Promise.all([__webpack_require__.e(290), __webpack_require__.e(9025)]).then(() => (() => (__webpack_require__("a2037f49db6530f88dd0"))))))),
	"0eec66805b8780559fc1": () => (loadStrictVersionCheckFallback("default", "redux", [1,4,1,0], () => (Promise.all([__webpack_require__.e(8612), __webpack_require__.e(593)]).then(() => (() => (__webpack_require__("c9ca76c9ad99b5dc059f"))))))),
	"7f013c602d7add0c1d3a": () => (loadStrictVersionCheckFallback("default", "react-dom", [1,17,0,2], () => (Promise.all([__webpack_require__.e(290), __webpack_require__.e(5105), __webpack_require__.e(3655)]).then(() => (() => (__webpack_require__("25c58b7157c0a383dbaf"))))))),
	"589035f897b44a5d05fd": () => (loadStrictVersionCheckFallback("default", "@wolffun/system-currency", [0], () => (Promise.all([__webpack_require__.e(5923), __webpack_require__.e(5737), __webpack_require__.e(4285), __webpack_require__.e(8396), __webpack_require__.e(5838)]).then(() => (() => (__webpack_require__("1052f6224f0d77a0b5ae"))))))),
	"065a73464aba9eb5d58d": () => (loadStrictVersionCheckFallback("default", "react-redux", [1,7,2,4], () => (Promise.all([__webpack_require__.e(8612), __webpack_require__.e(9220), __webpack_require__.e(3642), __webpack_require__.e(6418), __webpack_require__.e(9794), __webpack_require__.e(4709)]).then(() => (() => (__webpack_require__("346b03618e9b77086edb"))))))),
	"7258f13b853df385224b": () => (loadStrictVersionCheckFallback("default", "classnames", [1,2,3,1], () => (__webpack_require__.e(8260).then(() => (() => (__webpack_require__("f75641b373b8ef7d06cd"))))))),
	"818fb877bd24ff1daf6f": () => (loadStrictVersionCheckFallback("default", "@wolffun/contract-address", [0], () => (__webpack_require__.e(2577).then(() => (() => (__webpack_require__("75a134201065635b660d"))))))),
	"835ee72ee45db195a01e": () => (loadStrictVersionCheckFallback("default", "@wolffun/wallet-adapter", [0], () => (Promise.all([__webpack_require__.e(5923), __webpack_require__.e(1501)]).then(() => (() => (__webpack_require__("15a8c675bd5fa3772c31"))))))),
	"b08f9e55f18c6f14cc77": () => (loadStrictVersionCheckFallback("default", "styled-components", [1,5,3,0], () => (Promise.all([__webpack_require__.e(9115), __webpack_require__.e(4931), __webpack_require__.e(6280)]).then(() => (() => (__webpack_require__("cae4b85405c569bfaf8f"))))))),
	"d1c2433c54c38a2a97e2": () => (loadStrictVersionCheckFallback("default", "lodash", [1,4,17,21], () => (__webpack_require__.e(7913).then(() => (() => (__webpack_require__("a827fd8b51680bea2dca"))))))),
	"f936e86462712cc79d5c": () => (loadStrictVersionCheckFallback("default", "redux-thunk", [1,2,3,0], () => (__webpack_require__.e(623).then(() => (() => (__webpack_require__("b7d88d7ff8955d1b10d5"))))))),
	"0f39283b42a49153fe48": () => (loadStrictVersionCheckFallback("default", "dayjs", [1,1,10,7], () => (__webpack_require__.e(4920).then(() => (() => (__webpack_require__("edbe5dd45415a3c01c85")))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"768": [
		"589035f897b44a5d05fd"
	],
	"2324": [
		"0f39283b42a49153fe48"
	],
	"3090": [
		"4914e017dcea24a7ed64"
	],
	"3979": [
		"065a73464aba9eb5d58d",
		"7258f13b853df385224b",
		"818fb877bd24ff1daf6f",
		"835ee72ee45db195a01e"
	],
	"4285": [
		"2228aea9386c33236da4"
	],
	"4709": [
		"7f013c602d7add0c1d3a"
	],
	"6750": [
		"b08f9e55f18c6f14cc77",
		"d1c2433c54c38a2a97e2",
		"f936e86462712cc79d5c"
	],
	"8064": [
		"f936e86462712cc79d5c"
	],
	"8396": [
		"0eec66805b8780559fc1"
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}